import MeetingItemSchema from 'Shared/utils/normalizeJSON/schemas/MeetingItem.schema';
import normalizer from 'Shared/utils/normalizeJSON/normalizer';

import WpToastManager from 'Wpds/components/toast/WpToastManager';
import { jsonEmptyContentState } from 'Shared/utils/draftJsHelpers';
import { showNotificationError } from 'Shared/helpers';
import QueryParamConstants from '../constants/QueryParams.constants';
import MeetingItemsConstants from '../constants/MeetingItems.constants';

import MeetingItemHelper from '../model_helpers/MeetingItem.helper';
import * as MeetingItemsAPI from '../api/MeetingItems.api';

export const fetchMeetingItemsSuccess = payload => ({
  type: MeetingItemsConstants.Actions.FETCH_MEETING_ITEMS_SUCCESS,
  payload,
});

export const fetchSingleMeetingItemsSuccess = payload => ({
  type: MeetingItemsConstants.Actions.FETCH_SINGLE_MEETING_ITEMS_SUCCESS,
  payload,
});

export const fetchGoalActionItemsSuccess = payload => ({
  type: MeetingItemsConstants.Actions.FETCH_GOAL_ACTION_ITEMS_SUCCESS,
  payload,
});

export const fetchWorkspaceActionItemsSuccess = payload => ({
  type: MeetingItemsConstants.Actions.FETCH_WORKSPACE_ACTION_ITEMS_SUCCESS,
  payload,
});

export const createNewMeetingItemSuccess = payload => ({
  type: MeetingItemsConstants.Actions.CREATE_NEW_MEETING_ITEM_SUCCESS,
  payload,
});

export const updateCompleteStatusSuccess = payload => ({
  type: MeetingItemsConstants.Actions.UPDATE_COMPLETE_STATUS_SUCCESS,
  payload,
});

export const updateHighPrioritySuccess = payload => ({
  type: MeetingItemsConstants.Actions.UPDATE_HIGH_PRIORITY_SUCCESS,
  payload,
});

export const attachFileSuccess = payload => ({
  type: MeetingItemsConstants.Actions.ATTACH_FILE_SUCCESS,
  payload,
});

export const deleteMeetingItemSuccess = payload => ({
  type: MeetingItemsConstants.Actions.DELETE_MEETING_ITEM_SUCCESS,
  payload,
});

export const deleteFileAttachmentSuccess = payload => ({
  type: MeetingItemsConstants.Actions.DELETE_FILE_SUCCESS,
  payload,
});

export const updateShowPreviewSuccess = payload => ({
  type: MeetingItemsConstants.Actions.UPDATE_SHOW_PREVIEW_SUCCESS,
  payload,
});

export const updateDueBySuccess = payload => ({
  type: MeetingItemsConstants.Actions.UPDATE_DUE_BY_SUCCESS,
  payload,
});

export const updateRecurrenceSuccess = payload => ({
  type: MeetingItemsConstants.Actions.UPDATE_RECURRENCE_SUCCESS,
  payload,
});

export const deleteRecurrenceItemSuccess = payload => ({
  type: MeetingItemsConstants.Actions.DELETE_RECURRENCE_SUCCESS,
  payload,
});

export const updateAssigneeSuccess = payload => ({
  type: MeetingItemsConstants.Actions.UPDATE_ASSIGNEE_SUCCESS,
  payload,
});

export const createAsanaTaskSuccess = payload => ({
  type: MeetingItemsConstants.Actions.CREATE_ASANA_TASK_SUCCESS,
  payload,
});

export const disconnectAsanaTaskSuccess = payload => ({
  type: MeetingItemsConstants.Actions.DISCONNECT_ASANA_TASK_SUCCESS,
  payload,
});

export const updateItemBodySuccess = payload => ({
  type: MeetingItemsConstants.Actions.UPDATE_ITEM_BODY_SUCCESS,
  payload,
});

export const updateItemBodyInReduxSuccess = payload => ({
  type: MeetingItemsConstants.Actions.UPDATE_ITEM_BODY_IN_REDUX,
  payload,
});

export const removeNestingSuccess = payload => ({
  type: MeetingItemsConstants.Actions.REMOVE_NESTING_SUCCESS,
  payload,
});

export const createNewTempItemSuccess = payload => ({
  type: MeetingItemsConstants.Actions.CREATE_NEW_TEMP_MEETING_ITEM_SUCCESS,
  payload,
});

export const clearNewTempItemSuccess = () => ({
  type: MeetingItemsConstants.Actions.CLEAR_TEMP_MEETING_ITEM_SUCCESS,
});

export const deleteTempItemSuccess = payload => ({
  type: MeetingItemsConstants.Actions.DELETE_TEMP_MEETING_ITEM_SUCCESS,
  payload,
});

export const updateParentUuidSuccess = payload => ({
  type: MeetingItemsConstants.Actions.UPDATE_PARENT_UUID_SUCCESS,
  payload,
});

export const addToGoalSuccess = payload => ({
  type: MeetingItemsConstants.Actions.ADD_TO_GOAL_SUCCESS,
  payload,
});

export const removeFromGoalSuccess = payload => ({
  type: MeetingItemsConstants.Actions.REMOVE_FROM_GOAL_SUCCESS,
  payload,
});

export const convertItemSuccess = payload => ({
  type: MeetingItemsConstants.Actions.CONVERT_DISCUSSION_TOPIC_AND_ACTION_ITEM,
  payload,
});

export const duplicateItemSuccess = payload => ({
  type: MeetingItemsConstants.Actions.DUPLICATE_ITEM,
  payload,
});

export const removeNestingOnTempItem = (tempUuid, afterUuid) => ({
  type: MeetingItemsConstants.Actions.REMOVE_NESTING_OF_TEMP_ITEM_SUCCESS,
  payload: {
    [MeetingItemsConstants.Model.UUID]: tempUuid,
    [MeetingItemsConstants.Model.AFTER_UUID]: afterUuid,
  },
});

export const nestOnTempItem = (tempUuid, parentUuid, parentId) => ({
  type: MeetingItemsConstants.Actions.NEST_TEMP_ITEM_SUCCESS,
  payload: {
    [MeetingItemsConstants.Model.UUID]: tempUuid,
    [MeetingItemsConstants.Model.PARENT_UUID]: parentUuid,
    [MeetingItemsConstants.Model.PARENT_ID]: parentId,
    [MeetingItemsConstants.Model.AFTER_UUID]: parentUuid,
  },
});

export const deleteTempItem = tempUuid => ({
  type: MeetingItemsConstants.Actions.DELETE_TEMP_ITEM_SUCCESS,
  payload: {
    [MeetingItemsConstants.Model.UUID]: tempUuid,
  },
});

export const fetchMeetingItems = (context, params) => dispatch => {
  return MeetingItemsAPI.fetchMeetingItems(params)
    .then(response => {
      dispatch(fetchMeetingItemsSuccess(normalizer(MeetingItemSchema, response.data)));

      const payload = {
        data: response.data.data,
      };

      if (context === 'goal') {
        payload.goalSlug = params.goal_id;
        dispatch(fetchGoalActionItemsSuccess(payload));
      }

      if (context === 'workspace') {
        payload.workspaceSlug = params.workspace_id;
        dispatch(fetchWorkspaceActionItemsSuccess(payload));
      }
      return response;
    })
    .catch(error => {
      showNotificationError(error);
    });
};

export const fetchSingleMeetingItem = (meetingItemSlug, params) => dispatch => {
  return MeetingItemsAPI.fetchSingleMeetingItem(meetingItemSlug, params).then(response => {
    dispatch(fetchSingleMeetingItemsSuccess(normalizer(MeetingItemSchema, response.data)));
    return response;
  });
};

export const createNewMeetingItem = (data, context) => dispatch => {
  const dataToSend = {
    item: { ...data },
    [QueryParamConstants.Api.DATA_FORMAT]: QueryParamConstants.Api.JSONAPI,
  };

  return MeetingItemsAPI.createNewMeetingItem(dataToSend)
    .then(response => {
      dispatch(createNewMeetingItemSuccess(normalizer(MeetingItemSchema, response.data)));

      const payload = {
        data: [response.data.data],
      };

      if (context === 'goal') {
        payload.goalSlug = data.goalSlug;
        dispatch(fetchGoalActionItemsSuccess(payload));
      }

      dispatch(deleteTempItemSuccess(data.uuid));
      return response;
    })
    .catch(() => {
      WpToastManager.danger('An error occurred creating item.');
    });
};

export const updateCompleteStatus = (meetingItemSlug, data) => dispatch => {
  return MeetingItemsAPI.updateCompleteStatus(meetingItemSlug, data).then(response => {
    dispatch(updateCompleteStatusSuccess(normalizer(MeetingItemSchema, response.data)));
  });
};

export const updateHighPriority = (meetingItemSlug, data) => dispatch => {
  return MeetingItemsAPI.updateMeetingItem(meetingItemSlug, data).then(response => {
    dispatch(updateHighPrioritySuccess(normalizer(MeetingItemSchema, response.data)));
  });
};

export const attachFile = (meetingItemSlug, data) => dispatch => {
  data.append(QueryParamConstants.Api.DATA_FORMAT, QueryParamConstants.Api.JSONAPI);
  return MeetingItemsAPI.attachFile(meetingItemSlug, data).then(response => {
    dispatch(attachFileSuccess(normalizer(MeetingItemSchema, response.data)));
    return response.data;
  });
};

export const deleteAttachment = (meetingItemSlug, attachmentId) => dispatch => {
  const data = {
    [QueryParamConstants.Api.DATA_FORMAT]: QueryParamConstants.Api.JSONAPI,
    [QueryParamConstants.Api.MEETING_ITEM_ATTACHMENT_ID]: attachmentId,
  };
  return MeetingItemsAPI.deleteAttachment(meetingItemSlug, data).then(response => {
    dispatch(deleteFileAttachmentSuccess(normalizer(MeetingItemSchema, response.data)));
    return response.data;
  });
};

export const updateShowPreview = (meetingItemSlug, value) => dispatch => {
  const data = {
    [QueryParamConstants.Api.DATA_FORMAT]: QueryParamConstants.Api.JSONAPI,
    item: { [QueryParamConstants.Api.SHOW_PREVIEW]: value },
  };
  return MeetingItemsAPI.updateAttachmentPreview(meetingItemSlug, data).then(response => {
    dispatch(updateShowPreviewSuccess(normalizer(MeetingItemSchema, response.data)));
    return response.data;
  });
};

export const deleteMeetingItem = meetingItem => dispatch => {
  const meetingItemSlug = MeetingItemHelper.getUuid(meetingItem);
  // TODO: (josh): this currently only removes the actual meeting item,
  // and relies on the selector to return items that don't exist in the id arrary
  //  We need to remove the the id from all corresponding item arrays
  return MeetingItemsAPI.deleteMeetingItem(meetingItemSlug).then(() => {
    const payload = {
      meetingItemSlug,
    };
    dispatch(deleteMeetingItemSuccess(payload));
  });
};

export const updateDueBy = (meetingItemSlug, value) => dispatch => {
  const data = {
    [QueryParamConstants.Api.DATA_FORMAT]: QueryParamConstants.Api.JSONAPI,
    item: { [MeetingItemsConstants.Model.DUE_BY]: value },
  };
  return MeetingItemsAPI.updateMeetingItem(meetingItemSlug, data).then(response => {
    dispatch(updateDueBySuccess(normalizer(MeetingItemSchema, response.data)));
    return response.data;
  });
};

export const updateRecurringItem = (meetingItemSlug, recurringSettings, successMessage) => dispatch => {
  const data = {
    [QueryParamConstants.Api.DATA_FORMAT]: QueryParamConstants.Api.JSONAPI,
    ...recurringSettings,
  };
  return MeetingItemsAPI.updateRecurringItem(meetingItemSlug, data).then(response => {
    WpToastManager.success(successMessage || 'Recurrence created');
    dispatch(updateRecurrenceSuccess(normalizer(MeetingItemSchema, response.data)));
    return response.data;
  });
};

export const deleteRecurrenceItem = meetingItemSlug => dispatch => {
  const params = {
    [QueryParamConstants.Api.DATA_FORMAT]: QueryParamConstants.Api.JSONAPI,
  };
  return MeetingItemsAPI.deleteRecurrenceItem(meetingItemSlug, params).then(response => {
    WpToastManager.success('Recurrence deleted');
    dispatch(deleteRecurrenceItemSuccess(normalizer(MeetingItemSchema, response.data)));
    return response.data;
  });
};

export const updateAssignee = (meetingItemSlug, assigneeId) => dispatch => {
  const data = {
    [QueryParamConstants.Api.DATA_FORMAT]: QueryParamConstants.Api.JSONAPI,
    assignee_id: assigneeId,
  };
  return MeetingItemsAPI.updateAssignee(meetingItemSlug, data).then(response => {
    dispatch(updateAssigneeSuccess(normalizer(MeetingItemSchema, response.data)));
    return response.data;
  });
};

export const updateItemBody = (meetingItemSlug, body) => dispatch => {
  const data = {
    [QueryParamConstants.Api.DATA_FORMAT]: QueryParamConstants.Api.JSONAPI,
    item: { [MeetingItemsConstants.Model.BODY]: body },
  };
  return MeetingItemsAPI.updateMeetingItem(meetingItemSlug, data)
    .then(response => {
      dispatch(updateItemBodySuccess(normalizer(MeetingItemSchema, response.data)));
      return response.data;
    })
    .catch(() => {
      WpToastManager.danger('An error occurred updating item.');
    });
};

export const updateParentUuid = (meetingItemSlug, parentUuid) => dispatch => {
  const data = {
    [QueryParamConstants.Api.DATA_FORMAT]: QueryParamConstants.Api.JSONAPI,
    draggedItemUuids: [meetingItemSlug],
    [MeetingItemsConstants.Model.PARENT_UUID]: parentUuid,
  };
  return MeetingItemsAPI.updateParentUuid(data).then(response => {
    dispatch(updateParentUuidSuccess(normalizer(MeetingItemSchema, response.data)));
    return response.data;
  });
};

export const createAsanaTask = (meetingItemSlug, asanaProjectId) => dispatch => {
  const data = {
    [QueryParamConstants.Api.DATA_FORMAT]: QueryParamConstants.Api.JSONAPI,
    projectId: asanaProjectId,
  };
  return MeetingItemsAPI.createAsanaTask(meetingItemSlug, data).then(response => {
    WpToastManager.success('Asana Task Created!');
    dispatch(createAsanaTaskSuccess(normalizer(MeetingItemSchema, response.data)));
    return response.data;
  });
};

export const disconnectAsanaTask = (meetingItemSlug, asanaProjectId) => dispatch => {
  const data = {
    [QueryParamConstants.Api.DATA_FORMAT]: QueryParamConstants.Api.JSONAPI,
    projectId: asanaProjectId,
  };
  return MeetingItemsAPI.disconnectAsanaTask(meetingItemSlug, data).then(response => {
    WpToastManager.success('Disconnected Task from Asana!');
    dispatch(disconnectAsanaTaskSuccess(normalizer(MeetingItemSchema, response.data)));
    return response.data;
  });
};

export const addToGoal = (meetingItemSlug, goalSlug) => dispatch => {
  const data = {
    [QueryParamConstants.Api.DATA_FORMAT]: QueryParamConstants.Api.JSONAPI,
    goalId: goalSlug,
  };

  return MeetingItemsAPI.addToGoal(meetingItemSlug, data).then(response => {
    WpToastManager.success('Added to goal');
    dispatch(addToGoalSuccess(normalizer(MeetingItemSchema, response.data)));
    return response.data;
  });
};

export const removeFromGoal = meetingItemSlug => dispatch => {
  const data = {
    [QueryParamConstants.Api.DATA_FORMAT]: QueryParamConstants.Api.JSONAPI,
  };
  return MeetingItemsAPI.removeFromGoal(meetingItemSlug, data).then(response => {
    WpToastManager.success('Removed from goal');
    dispatch(removeFromGoalSuccess(normalizer(MeetingItemSchema, response.data)));
    return response.data;
  });
};

export const duplicateItems = ({
  itemUuids,
  duplicateFromWorkspaceId,
  duplicateToWorkspaceIds,
  isMoveItems,
}) => dispatch => {
  const data = {
    [QueryParamConstants.Api.DATA_FORMAT]: QueryParamConstants.Api.JSONAPI,
    itemUuids,
    duplicateFromWorkspaceId,
    duplicateToWorkspaceIds,
    isMoveItems,
  };

  return MeetingItemsAPI.duplicateItems(data).then(response => {
    dispatch(duplicateItemSuccess(normalizer(MeetingItemSchema, response.data)));
    if (isMoveItems) WpToastManager.success('Item moved');
    else WpToastManager.success('Item copied ');
  });
};

export const convertDiscussionTopicAndActionItem = ({ meetingItemSlug, newType, dueBy }) => dispatch => {
  const data = {
    [QueryParamConstants.Api.DATA_FORMAT]: QueryParamConstants.Api.JSONAPI,
    item: { [MeetingItemsConstants.Model.DUE_BY]: dueBy, [MeetingItemsConstants.Model.ITEM_TYPE]: newType },
  };

  return MeetingItemsAPI.updateMeetingItem(meetingItemSlug, data)
    .then(response => {
      dispatch(convertItemSuccess(normalizer(MeetingItemSchema, response.data)));
      WpToastManager.success('Item converted');
      return response.data;
    })
    .catch(() => {
      WpToastManager.danger('An error occurred updating item.');
    });
};

// This action does not make an API call - just updates the item in redux
export const updateItemBodyInRedux = (meetingItemSlug, body) => dispatch => {
  const payload = {
    meetingItemSlug,
    body,
  };
  return dispatch(updateItemBodyInReduxSuccess(payload));
};

export const removeNesting = (meetingItemSlug, afterUuid) => dispatch => {
  const data = {
    [QueryParamConstants.Api.DATA_FORMAT]: QueryParamConstants.Api.JSONAPI,
    item: {
      [MeetingItemsConstants.Model.UUID]: meetingItemSlug,
      [MeetingItemsConstants.Model.AFTER_UUID]: afterUuid,
    },
  };
  return MeetingItemsAPI.removeNesting(meetingItemSlug, data).then(response => {
    dispatch(removeNestingSuccess(normalizer(MeetingItemSchema, response.data)));
    return response.data;
  });
};

export const createNewTempItem = data => dispatch => {
  const dataForRedux = {
    [MeetingItemsConstants.Model.BODY]: jsonEmptyContentState(),
    [MeetingItemsConstants.Model.ATTACHMENTS]: [],
    ...data,
  };

  return dispatch(createNewTempItemSuccess(dataForRedux));
};

export const clearNewTempItems = () => dispatch => {
  return dispatch(clearNewTempItemSuccess());
};
